/**
 * Canonical media URL helper (P7).
 * - Absolute http(s)/data URLs pass through (Storage dual-read + CDN).
 * - Relative keys become `${REACT_APP_MEDIA_CDN_URL}/{key}`.
 */
const CDN = (process.env.REACT_APP_MEDIA_CDN_URL || '').replace(/\/$/, '');

export function mediaCdnBase(): string {
  return CDN;
}

export function isCdnUploadEnabled(): boolean {
  return Boolean(CDN);
}

/** Prefer CDN URL as-is; leave http(s)/data unchanged; prefix relative keys. */
export function toMediaUrl(url: string | null | undefined): string {
  if (!url) return '';
  if (/^https?:\/\//i.test(url) || url.startsWith('data:') || url.startsWith('blob:')) return url;
  if (CDN && !url.startsWith('http')) {
    return `${CDN}/${url.replace(/^\//, '')}`;
  }
  return url;
}

/** True if URL is already on our media CDN (or looks like an S3 media key). */
export function isCdnOrStorageUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  if (CDN && url.includes(CDN.replace(/^https?:\/\//, ''))) return true;
  if (url.includes('supabase.co/storage/')) return true;
  if (url.startsWith('media/')) return true;
  return /^https?:\/\//i.test(url);
}
